import { render, staticRenderFns } from "./family_detail.vue?vue&type=template&id=146eb840"
import script from "./family_detail.vue?vue&type=script&lang=js"
export * from "./family_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports